"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_native_1 = require("react-native");
const colors_1 = __importDefault(require("../../styles/colors"));
const styles = react_native_1.StyleSheet.create({
    subHeading: {
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: 12,
        lineHeight: 18,
        color: colors_1.default.FONT_GRAY,
    },
});
exports.default = styles;
